"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var column_root_dto_1 = require("./column-root-dto");
var row_root_dto_1 = require("./row-root-dto");
var table_grouping_dto_1 = require("./table-grouping-dto");
/**
 * Report object holds properties, categories DTOs, measures DTOs, used for querying and rendering report
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var ReportDto = /** @class */ (function () {
    function ReportDto() {
        this.columnRootDto = new column_root_dto_1.ColumnRootDto();
        this.rowRootDto = new row_root_dto_1.RowRootDto();
        this.tableGrouping = new table_grouping_dto_1.TableGroupingDto();
    }
    ReportDto.prototype.toJson = function () {
        return JSON.stringify(this);
    };
    return ReportDto;
}());
exports.ReportDto = ReportDto;
//# sourceMappingURL=report-dto.js.map